import React, { useEffect, useMemo, useRef, useState } from "react";
import { format } from "date-fns";
import "./Timeline.css";
import { useDispatch, useSelector } from "react-redux";
import { searchStacData } from "../../services/stac.service";
import { updateDate } from "../../slices/filtersSlice";

const Timeline = () => {
  const dispatch = useDispatch();
  const isLeftNavCollapsed = useSelector(state => state.leftNav.isCollapsed);
  const monthRange = useSelector(state => state.filters.monthRange);
  const collectionStats = useSelector(state => state.filters.collectionStats);
  const highlightedMonthRange = useSelector(state => state.search.highlightedMonthRange);
  const loadingSearchResults = useSelector(state => state.search.loadingSearchResults);

  const monthItemCounts = useMemo(() => {
    const counts = {};
    collectionStats.months.forEach(({ month, itemCount }) => {
      counts[month] = itemCount;
    });
    return counts;
  }, [collectionStats]);

  const [selectedWeekId, setSelectedWeekId] = useState(null);
  const [expandedWeekId, setExpandedWeekId] = useState(null);

  const clickTimerRef = useRef(null);
  const CLICK_DELAY = 200;


  const timelineItemsRef = useRef({}); // key: monthName  

  useEffect(() => {
    if (!highlightedMonthRange?.length) return;

    const targetMonth = highlightedMonthRange[0].toUpperCase();
    const el = timelineItemsRef.current[targetMonth];

    if (el) {
      el.scrollIntoView({
        behavior: "instant",
        block: "center",
        inline: "center",
      });
    }
  }, [highlightedMonthRange, monthRange, isLeftNavCollapsed]);

  const handleWeekClick = (week) => {
    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current);
    }

    clickTimerRef.current = setTimeout(() => {
      setSelectedWeekId(week.weekId);
      setExpandedWeekId(null);

      dispatch(updateDate({
        startDate: week.weekStart,
        endDate: week.weekEnd,
      }));
      dispatch(searchStacData());

      clickTimerRef.current = null;
    }, CLICK_DELAY);
  };

  // const handleWeekDoubleClick = (week) => {
  //   if (clickTimerRef.current) {
  //     clearTimeout(clickTimerRef.current);
  //     clickTimerRef.current = null;
  //   }

  //   setExpandedWeekId(prev =>
  //     prev === week.weekId ? null : week.weekId
  //   );
  // };

  // const handleDayClick = (day) => {
  //   dispatch(updateDate({
  //     startDate: day.date,
  //     endDate: day.date,
  //   }));

  //   dispatch(searchStacData());
  // };



  return (
    <div
      className={`customTimeline ${isLeftNavCollapsed ? "collapsed" : ""}`}
    >
      {monthRange.map((item) => {
        const monthName = item.monthName.toUpperCase();
        const isMonthHighlighted = highlightedMonthRange.includes(monthName);
        const monthKey = format(new Date(item.monthStartEndDates.startDate), "yyyy-MM");
        const itemCount = monthItemCounts[monthKey];

        return (
          <div
            key={monthName}
            className="customTimelineItem"
            ref={(el) => (timelineItemsRef.current[monthName] = el)}
            onClick={() => {
              if (loadingSearchResults) return;
              setSelectedWeekId(null);
              setExpandedWeekId(null);

              dispatch(updateDate(item.monthStartEndDates));
              dispatch(searchStacData());
            }}
            style={{
              backgroundColor: isMonthHighlighted
                ? "rgb(204, 245, 79, 0.5)"
                : "#0D0D0E",
            }}
          >
            {/* Month label */}
            <div className="customTimelineMonth">
              {item.monthName}
              {itemCount !== undefined && (
                <span className="customTimelineMonthCount">{itemCount} images</span>
              )}
            </div>

            {/* Weeks row (ALWAYS visible) */}
            <div className="customTimelineWeeks">
              {item.weeks.map((week) => {
                const isActive = selectedWeekId === week.weekId;

                return (
                  <div key={week.weekId}>
                    <div
                      className={`customTimelineWeek ${isActive ? "active" : ""
                        }`}
                      onClick={(e) => {
                        if (loadingSearchResults) return;
                        e.stopPropagation();
                        handleWeekClick(week);
                      }}
                      // onDoubleClick={(e) => {
                      //   e.stopPropagation();
                      //   handleWeekDoubleClick(week);
                      // }}
                    >
                      {week.weekLabel}
                    </div>

                    {/* Days row (only when expanded)
                    {expandedWeekId === week.weekId && (
                      <div className="customTimelineDaysRow">
                        {week.days.map((day) => (
                          <div
                            key={day.date}
                            className="customTimelineDay"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDayClick(day);
                            }}
                          >
                            {day.dayNumber}
                          </div>
                        ))}
                      </div>
                    )} */}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
